import { useState, useRef } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Image uploader. Props:
 *   onUploaded(result): result = { url, thumb_url, filename, size }
 *   buttonLabel
 */
const ImageUploader = ({ onUploaded, buttonLabel = "Bild hochladen", testId = "image-uploader" }) => {
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const result = {
        ...res.data,
        full_url: `${BACKEND_URL}${res.data.url}`,
        full_thumb_url: `${BACKEND_URL}${res.data.thumb_url}`,
      };
      toast.success("Bild hochgeladen");
      onUploaded?.(result);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload fehlgeschlagen");
    } finally {
      setLoading(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={handle} data-testid={`${testId}-input`} />
      <button
        type="button"
        onClick={() => ref.current?.click()}
        disabled={loading}
        data-testid={testId}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-primary/40 text-primary text-sm hover:bg-primary/5 disabled:opacity-50"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        {buttonLabel}
      </button>
    </>
  );
};

export default ImageUploader;
